"use client"

import { createContext, useContext } from "react"

interface SidebarContextValue {
  collapsed: boolean
  toggle: () => void
}

export const SidebarContext = createContext<SidebarContextValue | null>(null)

export function useSidebar(): SidebarContextValue {
  const ctx = useContext(SidebarContext)
  return ctx ?? { collapsed: false, toggle: () => {} }
}
